import { Colors } from '@styles/theme';
import styled, { css } from 'styled-components';
import { Sizes } from './types';

interface ContainerProps {
  size: Sizes;
  color: Colors;
  background: Colors;
}

export const Container = styled.div<ContainerProps>`
  &,
  svg {
    ${(props) =>
    props.size === 'lg' &&
    css`
        width: 2.5rem;
        height: 2.5rem;
      `}
    ${(props) =>
    props.size === 'md' &&
    css`
        width: 2rem;
        height: 2rem;
      `}
    ${(props) =>
    props.size === 'sm' &&
    css`
        width: 1.5rem;
        height: 1.5rem;
      `}
    ${(props) =>
    props.size === 'xsm' &&
    css`
        width: 1rem;
        height: 1rem;
      `}

    ${(props) =>
    props.background &&
    css`
        background-color: ${props.theme[props.background]};
      `}
  }

  svg {
    ${(props) =>
    props.color &&
    css`
        path {
          stroke: ${props.theme[props.color]};
          fill: ${props.theme[props.color]};
        }
      `}
  }
`;
